import "./footer.component.css"
import { Link } from "react-router-dom";
import LinkedInLogo from "../assets/linkedin_logo.png";
import MailLogo from "../assets/mail_logo.png";
import { ENV } from "../utils/envReader.util";
import TuranicsLogo from "../assets/turanics_logo_symbol_text.png";

/**
 * Footer component
 * @return Footer component
 */
function FooterComponent(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const {isEnglish, setIsEnglish} = props;

    return (
        <div id="footer"> {/* Background */}
            <div>
                <div className="w-100 flex column items-center gap-3">
                    <div className="flex column gap-2">
                        <div className="gap-3 flex center">
                            <a href="https://www.linkedin.com/in/heikewiesner/">
                                <img alt="linked in logo" src={LinkedInLogo} width="25px" height="25px" />
                            </a>
                            <a href={`mailto:${ENV.MAIL}`}>
                                <img alt="mail logo" src={MailLogo} width="25px" height="25px" />
                            </a>
                        </div>
                        <div className="flex gap-3 wrap center">
                            <Link to="/">
                                <p>Home</p>
                            </Link>
                            <Link to="/kontakt">
                                <p>{isEnglish ? "Imprint" : "Impressum"}</p>
                            </Link>
                        </div>
                    </div>
                    <a className="flex column center items-center gap-1 kaan" href="http://turanics.com/">
                        <p>{isEnglish ? "Made by" : "Erstellt von"}</p>
                        <img src={TuranicsLogo} alt="turanics logo" width={100} />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default FooterComponent;